import { delay } from 'util/promise'

export async function fetchRetry(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const ATTEMPTS = 3
  const DELAY = 3_000
  let attempt = 0
  while (true) {
    ++attempt
    try {
      return await fetch(input, init)
    } catch (e) {
      if (attempt < ATTEMPTS) await delay(DELAY)
      else throw new Error('fetch attempts failed')
    }
  }
}
